import styled from 'styled-components';

import MuiCheckbox from '@material-ui/core/Checkbox';

export const Checkbox = styled(MuiCheckbox)`
  margin: 0 8px 0 -2px;
  padding: 0;
`;
